import React, { FC } from 'react';
import { Box, Divider, Grid, makeStyles, Theme, Typography, useMediaQuery } from '@material-ui/core';
import { ReadButton } from 'components/atoms';
import { ListIcon, LocationIcon, TimeIcon, JobTypeIcon } from 'svgs/careers';
import { displayPublishAt } from 'utils/date';

export interface JobPositionProps {
  jobTitle: string;
  place: string;
  publicData: string;
  workExperience: string;
  description: string;
  href: string;
  jobType: string;
  shortNamePlace?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
  },
  mainDivider: {
    backgroundColor: '#E6E6E6',
    height: 2,
  },
  contentBox: {
    padding: theme.spacing(3, 3, 6),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(5.4),
    },
  },
  title: {
    fontWeight: 600,
    color: theme.palette.primary.dark,
    padding: theme.spacing(0.6, 0, 2),
  },
  text: {
    paddingLeft: theme.spacing(1),
  },
  icon: {
    marginTop: 3,
    marginRight: 3,
  },
  slash: {
    fontWeight: 500,
    padding: theme.spacing(0, 1.85),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 2),
    },
  },
  divider: {
    backgroundColor: theme.palette.secondary.light,
    marginBottom: theme.spacing(3),
  },
}));

const JobPosition: FC<JobPositionProps> = (props) => {
  const { jobTitle, place, publicData, workExperience, description, href, jobType, shortNamePlace } = props;
  const classes = useStyles();
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <>
      <Box className={classes.root}>
        <Divider className={classes.mainDivider} />
        <Box className={classes.contentBox}>
          <Typography variant="h5" className={classes.title}>
            {jobTitle}
          </Typography>
          <Grid direction="row" justify="flex-start" container>
            <Grid item>
              <Box display="flex" justifyContent="flex-start" flexDirection="row" pb={3.4} ml={isSmall ? 0 : -0.5}>
                <LocationIcon />
                <Typography color="textSecondary" className={classes.text}>
                  {place}, {shortNamePlace}
                </Typography>
                <Typography color="textSecondary" className={classes.slash}>
                  /
                </Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box display="flex" justifyContent="flex-start" flexDirection="row" pb={3.4}>
                <TimeIcon />
                <Typography color="textSecondary" className={classes.text}>
                  {displayPublishAt(publicData)}
                </Typography>
                <Typography color="textSecondary" className={classes.slash}>
                  /
                </Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box display="flex" justifyContent="flex-start" flexDirection="row" pb={3.4}>
                <JobTypeIcon className={classes.icon} />
                <Typography color="textSecondary" className={classes.text}>
                  {jobType}
                </Typography>
                <Typography color="textSecondary" className={classes.slash}>
                  /
                </Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box display="flex" justifyContent="flex-start" flexDirection="row" pb={3.4}>
                <ListIcon className={classes.icon} />
                <Typography color="textSecondary" className={classes.text}>
                  At least {workExperience}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Divider className={classes.divider} />
          <Typography color="textSecondary">{description}</Typography>
          <Box mt={5.4} />
          <ReadButton text="Learn more" href={href} orangeButton />
        </Box>
      </Box>
    </>
  );
};

export default JobPosition;
